var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{class:_vm.isOpen ? 'open' : ''},[_c('header',{on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }